import React from 'react';

import { bemBlock, Emblem } from '@neptune/shared/venus-ui';

import { ServiceAccountAvatar } from '../service-account-avatar/ServiceAccountAvatar';

import './ServiceAccountEmblem.less';

type ServiceAccountEmblemProps = React.ComponentProps<typeof Emblem>;

const block = bemBlock('service-account-emblem');

export const ServiceAccountEmblem = (props: ServiceAccountEmblemProps) => {
  return (
    <Emblem
      {...props}
      color="accent"
      endDetail="cross"
      className={block()}
      startDetail={<ServiceAccountAvatar size="xs" />}
    />
  );
};
